import React from 'react';

function LocalLoaderDark({message}) {
    return (
        <>
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-800 mx-auto my-auto"></div>
            <p className={'font-bold mt-8 text-columbia_blue-900'}>{message}</p>
        </>
    );
}

export default LocalLoaderDark;